import { useState } from "react";
import "./Testimonials.css";
import Header from "../../../components/Headers/Header";
// import image1 from '../../../assets/Home-Page-Assets/club-oxbury-logo.png';
// import image2 from '../../../assets/Home-Page-Assets/founders-logo.png';


const testimonialsData = [
  {
    id: 1,

    text: "The overall service from Belsoft Systems was great. They were responsive and attentive to our needs throughout the development process.",
    textShort: "The overall service from Belsoft Systems was great. They were responsive...",
    name: "Club Oxbury",
    role: "Community",
    img: "/club-oxbury-logo.png",
  },
  {
    id: 2,
    text: "My team and I look forward to more projects with the Belsoft team and we'll definitely recommend them to any organisation looking for an experienced and qualified dev team.",
    textShort: "My team and I look forward to more projects with the Belsoft team and...",
    name: "Founders Friday",
    role: "Community",
    img: "/founders-logo.png",
  },
  {
    id: 3,
    text: "Working with Belsoft Systems was a pleasure. Their team was attentive, efficient, and committed to delivering a top-notch result that aligned with our vision.",
    textShort: "Working with Belsoft Systems was a pleasure. Their team was attentive...",
    name: "Ordesea Resources Limited",
    role: "A Company",
    img: "/ordesea.png",
  },

];

function Testimonials() {
  const [activeTestimonial, setActiveTestimonial] = useState(testimonialsData[0]);

  return (
    <section className="testimonials-block">
      <Header
        headerTitle="Testimonials"
        headerContent="Our Clients Share Their Experiences: Discover the Difference We Make"
      />
      <div className="testimonials-body">
        <div className="testimonials-container">
          <div className="testimonial-main">
            <div className="quote-icon-left">“</div>
            <p className="testimonial-text">{activeTestimonial.text}</p>
            <div className="quote-icon-right">”</div>
            <div className="testimonial-author">
              <img src={activeTestimonial.img} alt={activeTestimonial.name} className="author-img" />
              <div className="author-info">
                <h4>{activeTestimonial.name}</h4>
                <p>{activeTestimonial.role}</p>
              </div>
            </div>
          </div>
          <div className="testimonial-thumbnails">
            {testimonialsData.map((testimonial) => (
              <div
                key={testimonial.id}
                className={`thumbnail ${activeTestimonial.id === testimonial.id ? "active" : ""}`}
                onClick={() => setActiveTestimonial(testimonial)}
              >
                <div className="thumbnail-user">
                  <img src={testimonial.img}
                    alt={testimonial.name}
                    className="thumbnail-img" />
                  <div className="thumbnail-info">
                    <h5>{testimonial.name}</h5>
                    <p>{testimonial.role}</p>
                  </div>
                </div>

                <div className="thumbnail-text">
                  <div className="quote-icon-left-small">“</div>
                  <p>{testimonial.textShort}</p>
                  <div className="quote-icon-right-small">”</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;